// Libraries
declare const module: any;
import { Provider } from 'mobx-react';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { AppContainer } from 'react-hot-loader';

// Components
import App from './src/App';

// Store
import stores from './src/stores/AllStores';
// Initialize React
ReactDOM.render(
  <Provider store={stores}>
    <AppContainer>
      <App />
    </AppContainer>
  </Provider>,
  document.getElementById('root')
);

if (
  typeof module !== 'undefined' &&
  typeof module.hot !== 'undefined' &&
  module.hot
) {
  module.hot.accept('./src/App', () => {
    ReactDOM.render(
      <Provider store={stores}>
        <AppContainer>
          <App />
        </AppContainer>
      </Provider>,
      document.getElementById('root')
    );
  });
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/index.tsx